// extracted by mini-css-extract-plugin
export var copyable = "_j-1";
export var explainable = "_j-0";
export var negative = "_j-2";
export var positive = "_j-3";